import React from "react";
import { useNavigate } from "react-router-dom";
import Modalheader from "components/modal/components/header";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";

// Leaving the job template wizard: same confirmation as leaving the mission creation.
const CloseTemplateProcess = () => {
    const navigate = useNavigate();
    const { toggle } = useModal();
    const { resetTemplateData, language } = UseContext();
    const label = (key, fallback) => language.getValue(`missionTemplate.wizard.${key}`, fallback);

    const handleLeave = () => {
        resetTemplateData();
        toggle();
        navigate("/missionTemplates");
    };

    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                icon="warning"
                description={label(
                    "leaveConfirm",
                    "Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées."
                )}
            >
                {label("leaveTitle", "Quitter la création de fiche de poste")}
            </Modalheader>
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    {label("leaveCancel", "Annuler")}
                </Button>
                <Button size={"LG"} onClick={handleLeave}>
                    {label("leaveSubmit", "Confirmer")}
                </Button>
            </ModalFooter>
        </>
    );
};

export default CloseTemplateProcess;
